import { createPermission } from '@backstage/plugin-permission-common';

// Frontend-side mirror of the permissions declared in
// packages/backend/src/extensions/keyVault.ts. Same string names — the
// permission framework keys decisions by name, not by reference identity, so
// the duplicate `createPermission` calls are intentional. Re-declaring here
// keeps frontend imports off the backend package (which would otherwise pull
// node-only deps, incl. the Azure SDK, into the browser bundle).
export const keyVaultSecretWritePermission = createPermission({
  name: 'keyVault.secret.write',
  attributes: { action: 'create' },
});

export const keyVaultSecretListPermission = createPermission({
  name: 'keyVault.secret.list',
  attributes: { action: 'read' },
});
